module.exports = __webpack_public_path__ + "img/GooglePlay.6bb864c3.png";